import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { PortalDigestSettings } from '../model/types';

export const getDigestSettingsAPI = async () => {
  const response = await baseAPI.get<PortalDigestSettings>(
    '/portal-digest/settings',
  );
  return response.data;
};

export const useGetDigestSettings = () => {
  return useQuery({
    queryKey: [KEYS.PORTAL_DIGEST_SETTINGS],
    queryFn: () => getDigestSettingsAPI(),
    retry: false,
  });
};
